import { ReactNode, createContext, useContext, useEffect } from 'react';
import { useGraphContext } from '../../context';
import type { NodeId } from '../../types/graph';

type NodeConfigContextValue = {
  nodeId: NodeId;
};

const NodeConfigContext = createContext<NodeConfigContextValue | null>(null);

type NodeConfigProviderProps = {
  nodeId: NodeId;
  children: ReactNode;
};

export const NodeConfigProvider = ({
  nodeId,
  children,
}: NodeConfigProviderProps) => {
  const [closeDrawer, hasNode] = useGraphContext(({ ui, graph: g }) => [
    ui.closeDrawer,
    Boolean(g.get().nodes[nodeId]),
  ]);

  useEffect(() => {
    if (!hasNode) {
      closeDrawer();
    }
  }, [closeDrawer, hasNode]);

  if (!hasNode) {
    return null;
  }

  return (
    <NodeConfigContext.Provider value={{ nodeId }}>
      {children}
    </NodeConfigContext.Provider>
  );
};

export const useNodeConfig = () => {
  const context = useContext(NodeConfigContext);
  if (!context) {
    throw new Error('useNodeConfig must be used inside NodeConfigProvider');
  }
  return context;
};
